var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0335 3.23358C6.21164 1.05544 9.7431 1.05544 11.9212 3.23358C14.0994 5.41171 14.0994 8.94317 11.9212 11.1213L11.1609 11.8732C10.6005 12.4233 9.8734 13.1304 8.9793 13.9949C8.42058 14.5351 7.53417 14.535 6.97553 13.9947L4.73931 11.8195C4.45826 11.5435 4.223 11.3108 4.0335 11.1213C1.85537 8.94317 1.85537 5.41171 4.0335 3.23358ZM11.2418 3.91298C9.43891 2.11007 6.51582 2.11007 4.71291 3.91298C2.91 5.71589 2.91 8.63899 4.71291 10.4419L5.66546 11.3819C6.19001 11.8953 6.84943 12.5361 7.64351 13.3041C7.82972 13.4842 8.12519 13.4842 8.31143 13.3041L10.486 11.1894C10.7864 10.8945 11.0384 10.6454 11.2418 10.4419C13.0447 8.63899 13.0447 5.71589 11.2418 3.91298ZM7.97737 5.43109C9.03922 5.43109 9.90001 6.29188 9.90001 7.35373C9.90001 8.41558 9.03922 9.27638 7.97737 9.27638C6.91552 9.27638 6.05472 8.41558 6.05472 7.35373C6.05472 6.29188 6.91552 5.43109 7.97737 5.43109ZM7.97737 6.39191C7.44617 6.39191 7.01555 6.82253 7.01555 7.35373C7.01555 7.88493 7.44617 8.31555 7.97737 8.31555C8.50857 8.31555 8.93919 7.88493 8.93919 7.35373C8.93919 6.82253 8.50857 6.39191 7.97737 6.39191Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.73b9d1bace21f5284feb4fca6c1b87ed.svg";
export { ForwardRef as ReactComponent };